import React from "react";
import { Button } from "../../../components/ui";
import { Loader2, Plus, RefreshCw } from "lucide-react";

export default function Toolbar({ 
  loading, 
  onRefresh, 
  canCreateLead, 
  onAddLead, 
  leadCreationMessage 
}) {
  return (
    <div className="toolbar">
      <div>
        <div className="title">Lead Maker Dashboard</div>
        <div className="subtitle">Submit new leads and track approvals</div>
      </div>
      <div className="flex flex-col items-end">
        <div className="flex flex-row gap-2 items-center">
          <Button
            variant="outline"
            onClick={onRefresh}
            disabled={loading}
          >
            {loading ? (
              <>
                <Loader2 className="h-4 w-4 mr-2 animate-spin" />
                Refreshing...
              </>
            ) : (
              <>
                <RefreshCw className="h-4 w-4 mr-2" />
                Refresh
              </>
            )}
          </Button>
          <Button
            onClick={onAddLead}
            className="bg-green-600 hover:bg-green-700"
            disabled={!canCreateLead}
            title={leadCreationMessage || 'Create a new lead'}
          >
            <Plus className="h-4 w-4 mr-2" />
            Add Lead
          </Button>
        </div>
        {leadCreationMessage && (
          <div className="text-sm text-amber-600 mt-2">
            ℹ️ {leadCreationMessage}
          </div>
        )}
      </div>
    </div>
  );
}

